
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressGICsEN]",
      function () {
        return require("private-next-pages/[...wordpressGICsEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressGICsEN]"])
      });
    }
  